import {
  beAutomatioApiGetConditionsdescription,
  beAutomationApiGetExecutionStats,
  beAutomationApiGetLastExecutionForRecipient,
  beAutomationApiGetWorkflowDetails,
  beAutomationApiHasTaskEverSent,
  beAutomationApiSearchTasks,
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'
import {
  beRecipientApiSearchForRecipients,
  beRecipientGetDynamicFieldsDefinition
} from 'Api/beRecipientApi'
import { storeGet } from 'mailup-react-helpers'
import { STORE_KEY_ID_LIST } from 'Constants/index'
import { beEmailMessageGetMessageLazyDetails } from 'Api/beEmailMessageApi'
import { beSmsMessageGetSMSDetails } from 'Api/beSmsMessageApi'
import {
  statisticsApiGetMessageStatsForSpecificRecipient,
  statisticsGetMessageTotalCounters
} from 'Api/statisticsApi'
import {
  beSmsServicesCountMessageClicks,
  beSmsServicesCountMessageDeliveries,
  beSmsServicesCountMessageSent
} from 'Api/beSmsServicesApi'

export async function getWorkflowDetails(idWorkflow) {
  const result = await beAutomationApiGetWorkflowDetails(idWorkflow)
  const { Step: steps } = result
  const newSteps = []

  for (let i = 0; i < steps.length; i++) {
    if (steps[i].IdMessage === -1) {
      newSteps.push({ message: steps[i + 1], timeCondition: steps[i] })
      i++
    } else {
      newSteps.push({ message: steps[i] })
    }
  }

  return { name: result.Name, steps: newSteps }
}

export async function getRecipientDynamicFields() {
  const result = await beRecipientGetDynamicFieldsDefinition()
  return result
}

export async function getConditionsDescription(idWorkflow) {
  const data = {
    ConditionsOption: {
      ShowLink: false,
      LinkPlaceholders: {
        Begin: '<extlink>',
        End: '</extlink>'
      }
    }
  }

  const result = await beAutomatioApiGetConditionsdescription(idWorkflow, data)
  return result
}

export async function getRecipientByEmailOrSms(searchText) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const channel = searchText.includes('@') ? 'Email' : 'Sms'

  const searchParams = {
    channel,
    status: ['Subscribed', 'Pending', 'Unsubscribed']
  }

  const searchConditions = {
    DateRanges: {},
    IncludeGroups: [],
    ExcludeGroups: [],
    MatchingFields: [],
    MatchingFilters: {},
    UnsubscriptionType: '',
    UnsubscriptionSubType: '',
    UnsubscriptionMessage: 0,
    Email: channel === 'Email' ? searchText : '',
    EmailMatchType: 'EXACT',
    MobilePrefix: '',
    MobileNumber: channel === 'Sms' ? searchText : ''
  }
  const result = await beRecipientApiSearchForRecipients(
    idList,
    searchParams,
    searchConditions
  )

  if (result.Items.length > 0) {
    const id = result.Items[0].Id
    const recipientContact =
      channel === 'Email'
        ? result.Items[0].Email
        : result.Items[0].MobilePrefix + result.Items[0].MobileNumber
    const subscribedOn =
      result.Items[0].SubscriptionDate ||
      result.Items[0].SubscriptionRequestDate

    return { id, recipientContact, subscribedOn, totalItems: result.TotalItems }
  }

  return {
    id: 0,
    recipientContact: undefined,
    subscribedOn: undefined,
    totalItems: 0
  }
}

export async function getMessageDetails(idMessage, messageType) {
  let result
  if (messageType === WORKFLOW_MESSAGE_TYPE_EMAIL) {
    const emailDetail = await beEmailMessageGetMessageLazyDetails(idMessage)
    result = { subject: emailDetail.Subject }
  }
  if (messageType === WORKFLOW_MESSAGE_TYPE_SMS) {
    const smsDetail = await beSmsMessageGetSMSDetails(idMessage)
    result = { subject: smsDetail.Subject }
  }
  return result
}

export function getWaitingStepsDetails(timeCondition, waitSteps) {
  return waitSteps.find((step) => step.IdStep === timeCondition.Id)
}

export async function getTotalCounters(idMessage, messageType) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const types = ['CU', 'AUI', 'EI', 'RIT']

  if (messageType === WORKFLOW_MESSAGE_TYPE_EMAIL) {
    const { Status, Counters } = await statisticsGetMessageTotalCounters(
      idList,
      idMessage,
      types
    )

    if (Status === 'OK') {
      const {
        TotalCounters: { CU, AUI, EI, RIT }
      } = Counters
      return { cu: CU, aui: AUI, ei: EI, rec: EI - RIT }
    }
  }

  if (messageType === WORKFLOW_MESSAGE_TYPE_SMS) {
    const { Data: clicks } = await beSmsServicesCountMessageClicks(idMessage)
    const { Data: deliveries } =
      await beSmsServicesCountMessageDeliveries(idMessage)
    const { Data: sent } = await beSmsServicesCountMessageSent(idMessage)

    return { cu: clicks, aui: deliveries, ei: sent, rec: sent }
  }

  return { cu: 0, aui: 0, ei: 0, rec: 0 }
}

export async function getTasksStats(steps) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const emailIds = steps
    .filter((step) => step.message && step.message.MessageType === 0)
    .map((step) => step.message.IdMessage)

  const smsIds = steps
    .filter((step) => step.message && step.message.MessageType === 1)
    .map((step) => step.message.IdMessage)

  const params = { pageSize: 0, pageNumber: 1, orderDescending: true }

  const bodyParamsEmail = {
    SearchText: '',
    Action: 'Email',
    Hide: true,
    IdMessages: emailIds || []
  }

  const bodyParamsSms = {
    SearchText: '',
    Action: 'Sms',
    Hide: true,
    IdMessages: smsIds || []
  }

  const [emailTasks, smsTasks] = await Promise.all([
    emailIds.length > 0 &&
      beAutomationApiSearchTasks(idList, params, bodyParamsEmail),
    smsIds.length > 0 &&
      beAutomationApiSearchTasks(idList, params, bodyParamsSms)
  ])

  const idsTask = []
  const noResult = []

  if (emailTasks) {
    const emailToPush = emailTasks.Items.map((item) => {
      return {
        idMessage: item.Detail.IdMessage,
        idTrigger: item.Id
      }
    })
    idsTask.push(...emailToPush)
  } else {
    const emailToPush = emailIds.map((item) => ({
      idMessage: item,
      idTask: 0
    }))
    noResult.push(...emailToPush)
  }

  if (smsTasks) {
    const smsToPush = smsTasks.Items.map((item) => ({
      idMessage: item.Detail.IdMessage,
      idTrigger: item.Id
    }))
    idsTask.push(...smsToPush)
  } else {
    const smsToPush = emailIds.map((item) => ({
      idMessage: item,
      idTask: 0
    }))
    noResult.push(...smsToPush)
  }

  const calls =
    idsTask &&
    idsTask.map(async ({ idTrigger, idMessage }) => {
      const { Result } = await beAutomationApiHasTaskEverSent(idTrigger)
      return {
        idMessage,
        idTask: idTrigger,
        hasTriggered: Result
      }
    })

  const stepsHaveTriggered =
    calls.length > 0 ? await Promise.all(calls) : noResult

  return { stepsHaveTriggered }
}

export async function getExecutionDates(idTask) {
  const {
    FirstExecutionDate: firstExecutionDate,
    LastExecutionDate: lastExecutionDate
  } = await beAutomationApiGetExecutionStats(idTask)

  return { firstExecutionDate, lastExecutionDate }
}

export async function getMessagesStatsForSpecificRecipient(idRecipient, steps) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const params = {
    idrecipient: idRecipient,
    pagesize: 20,
    pagenumber: 1,
    getsendtrace: true
  }
  const calls = steps.map(async ({ idMessage, idTask }) => {
    const { Counters } = await statisticsApiGetMessageStatsForSpecificRecipient(
      idList,
      idMessage,
      params
    )

    if (Counters.TotalItems > 0) {
      const {
        ClickStats: { TotalCounter: totalClicks },
        OpeningStats: { TotalCounter: totalOpenings },
        SendtraceStats: { TotalCounter: totalSends }
      } = Counters.RecipientCounters[0]

      let lastExecutionDate
      if (totalSends >= 0) {
        const result = await beAutomationApiGetLastExecutionForRecipient(
          idTask,
          idRecipient
        )
        lastExecutionDate = result.Result
      } else {
        lastExecutionDate = undefined
      }

      return {
        result: { totalSends, totalOpenings, totalClicks, lastExecutionDate },
        idMessage
      }
    }

    return {
      result: {
        totalSends: 0,
        totalOpenings: 0,
        totalClicks: 0,
        lastExecutionDate: undefined
      },
      idMessage
    }
  })
  const allResults = await Promise.all(calls)

  return allResults
}
